import { AxiosResponse } from "axios";
import { BASE_METHODS, CustomErrorType } from "../../constants/action-types";
import { SuccessDTO } from "../../constants/dto/success";
import {
  removePushMessageFromPushMessages,
  setPushMessageActionStart,
  setPushMessageErrorMessage,
} from "../../constants/reducers/push-message.reducer";
import { store } from "../../store";
import { createCall } from "../base";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";

type deletepushMessageParam = {
  id: number;
};

let body: SuccessDTO;

export const deletePushMessage = async ({ id }: deletepushMessageParam) => {
  store.dispatch(setPushMessageActionStart(true));
  const request = await createCall(
    `cms/push-messages/delete/${id}`,
    BASE_METHODS.DELETE,
    "application/json",
    "1.0.0",
    undefined,
    undefined
  );

  try {
    const response = request as AxiosResponse;
    body = plainToClass(SuccessDTO, response.data);
    const errors = await validate(body);
    if (errors.length > 0) {
      store.dispatch(
        setPushMessageErrorMessage(TextEnum.DELETE_PUSH_MESSAGE_INVALID_RESPONSE)
      );
      return;
    }
    store.dispatch(removePushMessageFromPushMessages(id));
    return response;
  } catch (error) {
    const responseError = request as any;
    const errorResponeData: CustomErrorType = responseError.response?.data;
    if (errorResponeData) {
      let errorMessage = "";
      switch (errorResponeData.code) {
        case 8002:
          errorMessage = TextEnum.DELETE_PUSH_MESSAGE_NOT_FOUND;
          break;
        default:
          break;
      }
      store.dispatch(setPushMessageErrorMessage(errorMessage));
      return;
    }
    store.dispatch(setPushMessageActionStart(false));
    store.dispatch(timeoutError());
    return;
  }
};
